class SaveCPUPlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager) {
        super(pluginManager);

        // Configurable Properties
        this._renderOnFPS = 30;
        this._tsdiff = 0;
        this.renderOnPointerChange = false;
        this.renderDirty = true;

        // FPS default
        this.renderOnFPS = 30;
        this.fpsDirty = false;
        this.hrts = 0;

        // Initialize the plugin
        this.init();
    }

    init() {
        // Setters and Getters for renderOnFPS
        Object.defineProperty(this, "renderOnFPS", {
            get: function () {
                return this._renderOnFPS;
            },
            set: function (v) {
                this._renderOnFPS = v;
                this._tsdiff = 1000 / v;
            },
        });

        // Initialize the plugin based on the existence of updateRender
        if (this.game.updateRender) {
            this._init0();
        } else {
            this._init1();
        }

        // Track FPS using requestAnimationFrame
        this._trackFPS();
    }

    _init0() {
        // Phaser 3.55 equivalent initialization for renderType
        this.renderType = this.game.renderer.type;
        this.switchRender = this._switchRender0.bind(this);
    }

    _init1() {
        // Phaser 3.55 equivalent initialization for updateRender
        this.game.updateRenderReal = this.game.updateRender;
        this.game.updateRenderNull = function () {};
        this.switchRender = this._switchRender1.bind(this);
    }

    _trackFPS() {
        // Track FPS using requestAnimationFrame
        const diff = performance.now() - this.hrts;
        if (diff > this._tsdiff) {
            this.fpsDirty = true;
            this.hrts = performance.now();
        }

        requestAnimationFrame(this._trackFPS.bind(this));
    }

    _switchRender0() {
        // Phaser 3.55 equivalent for switching renderType
        this.game.renderer.type = this.renderDirty ? this.renderType : Phaser.Renderer.HEADLESS;
        this.renderDirty = false;
    }

    _switchRender1() {
        // Phaser 3.55 equivalent for switching updateRender
        this.game.updateRender = this.renderDirty ? this.game.updateRenderReal : this.game.updateRenderNull;
    }

    forceRender() {
        // Force rendering during the core game loop
        this.renderDirty = true;
    }

    _forceRenderOnPointerChange() {
        // Phaser 3.55 equivalent for forceRender on pointer change
        if (!this.renderOnPointerChange) {
            return false;
        }

        const input = this.game.input;

        if (input.oldx !== input.x || input.oldy !== input.y) {
            this.forceRender();
            input.oldx = input.x;
            input.oldy = input.y;
        }

        if (input.oldDown !== input.activePointer.isDown) {
            this.forceRender();
            input.oldDown = input.activePointer.isDown;
        }

        return true;
    }

    _forceRenderOnFPS() {
        // Phaser 3.55 equivalent for forceRender based on FPS
        if (this.renderOnFPS && this.fpsDirty) {
            this.fpsDirty = false;
            this.forceRender();
            return true;
        } else {
            return false;
        }
    }

    postUpdate() {
        // Phaser 3.55 equivalent for postUpdate
        if (this.renderDirty || this._forceRenderOnFPS() || this._forceRenderOnPointerChange()) {
            this.switchRender();
        }
    }

    postRender() {
        // Phaser 3.55 equivalent for postRender
        if (this.renderDirty) {
            this.renderDirty = false;
            this.switchRender();
        }
    }
}
export default SaveCPUPlugin;
